<template>
  <div>
    <!-- <button @click="loginUser">Log in</button> -->
    <div v-if="isLoading">
      <!-- <h1> loading ... </h1> -->
      <img src="./assets/Dapta-Brandmark-RGB.png" class="rotate" width="70" height="70" />
    </div>

    <router-view></router-view>
  </div>
</template>

<script lang="ts" setup>
import { ref, provide, inject } from "vue";
import { useRouter } from 'vue-router'
import { useAuth0 } from '@auth0/auth0-vue';
const { loginWithRedirect, isAuthenticated, idTokenClaims, getAccessTokenSilently } = useAuth0();
const router = useRouter();
const isLoading = ref(true);
const accessToken = ref();
const authAPIEndPoint = inject('auth_API_end_point');

// disable logging
var DEBUG = false;
if(!DEBUG){
    if(!window.console) window.console = {};
    var methods = ["log", "debug", "warn", "info"];
    for(var i=0;i<methods.length;i++){
        console[methods[i]] = function(){};
    }
}

router.beforeEach(async (to, from) => {
  const { requiresAuth } = to.meta
  if (requiresAuth) {
    try {
      accessToken.value = await getAccessTokenSilently();
      const permission = await fetch(authAPIEndPoint + "/get_user_subscriptions", {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${accessToken.value}`
        }
      }).then(
        (response) => {
          if (response.ok) {
            return response.json()
          } else {
            return { "status": "Forbidden" }
          }
        }
      ).then((data) => {
        isLoading.value = false
        if (data["status"] === "Success") {
          console.log("User permissions verified.")
          return true
        } else {
          console.log("Access Forbidden.")
          return '/403'
        }
      })
      return permission
    } catch (e) {
      console.log("Permissions check failed.")
      isLoading.value = false
      return '/403'
    }

  } else { 
    return true
  }

})

router.beforeResolve(async to => {
  if (to.path == "/") {
    console.warn("redirect")
    router.push('/interface')
  }
})

const loginUser = async () => {
  if (isAuthenticated) {
    provide("userJWTToken", accessToken)
    console.log("User Authenticated.")
    } else {
      loginWithRedirect()
      provide("userJWTToken", accessToken)
    }
}
loginUser()
</script>

<style scoped>
.rotate {
  animation: rotation 3s infinite linear;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top:  200px;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

</style>